(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["after-before-image-2"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.after-before-swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    centeredSlides: true,
    pagination: {
      el: '.after-before-swiper .swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.after-before-swiper .swiper-button-next',
      prevEl: '.after-before-swiper .swiper-button-prev'
    },
    loop: true,
    breakpoints: {
      1024: {
        slidesPerView: 3.2,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 20
      },
      540: {
        slidesPerView: 1.8,
        spaceBetween: 20
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["after-before-image"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.after-before-swiper', {
    slidesPerView: 1.1,
    spaceBetween: 10,
    centeredSlides: true,
    pagination: {
      el: '.after-before-swiper .swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.after-before-swiper .swiper-button-next',
      prevEl: '.after-before-swiper .swiper-button-prev'
    },
    loop: true,
    breakpoints: {
      1024: {
        slidesPerView: 3.2,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2.2,
        spaceBetween: 20
      },
      540: {
        slidesPerView: 1.8,
        spaceBetween: 20
      }
    }
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-videos"] && !Shopify.designMode) return;
  try {
    
  var swiperInstances = {}
  document.querySelectorAll('.video-slider').forEach((el, index) => {
    // find pagination and nav buttons *inside this container*
    var paginationEl = el.querySelector('.video-slider .swiper-pagination')
    var nextEl = el.querySelector('.video-slider .swiper-button-next')
    var prevEl = el.querySelector('.video-slider .swiper-button-prev')
    var swiper = new Swiper(el, {
      slidesPerView: 3.6,
      spaceBetween: 10,
      centeredSlides: true,
      loop: true,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl
      },
      breakpoints: {
        0: { slidesPerView: 1.2 },
        768: { slidesPerView: 2 },
        1200: { slidesPerView: 3.6 }
      }
    })
    swiperInstances[el.id] = swiper
  })

  // Tabs switching
  document.querySelectorAll('.tab-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      // Remove 'active' from all buttons and add to clicked one
      document.querySelectorAll('.tab-btn').forEach((b) => b.classList.remove('active'))
      btn.classList.add('active')
      // Hide all swiper containers
      document.querySelectorAll('.video-slider').forEach((tab) => tab.classList.add('hidden'))
      // Show selected tab
      let id = btn.getAttribute('data-tab')
      let activeSwiper = document.getElementById(id)
      activeSwiper.classList.remove('hidden')
      // 🔄 Recalculate Swiper layout for visible tab
      if (swiperInstances[id]) {
        swiperInstances[id].update()
      }
    })
  })

  // Video play/pause
  document.querySelectorAll('.video-card video').forEach((video) => {
    video.addEventListener('click', () => {
      let overlay = video.parentElement.querySelector('.video-overlay')
      if (video.paused) {
        document.querySelectorAll('.video-card video').forEach((v) => v.pause())
        video.play()
        overlay.style.display = 'none'
      } else {
        video.pause()
        overlay.style.display = 'block'
      }
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.how-to-use-section')
    if (!section) return
    const swiperContainer = section.querySelector('.steps-grid.swiper.enable-mobile-slider')
    if (!swiperContainer) return
    let swiperInstance = null
    // 🟢 Save original inline styles before Swiper modifies DOM
    const originalStyle = swiperContainer.getAttribute('style')
    function createSwiper() {
      if (swiperInstance) return
      const paginationEl = swiperContainer.querySelector('.swiper-pagination')
      const nextEl = swiperContainer.querySelector('.swiper-button-next')
      const prevEl = swiperContainer.querySelector('.swiper-button-prev')
      swiperInstance = new Swiper(swiperContainer, {
        slidesPerView: 1.2,
        spaceBetween: 10,
        loop: false,
        observer: true,
        observeParents: true,
        pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
        navigation: {
          nextEl: nextEl || undefined,
          prevEl: prevEl || undefined
        },
        breakpoints: {
          0: {
            slidesPerView: 1.05,
            spaceBetween: 8
          },
          576: {
            slidesPerView: 1.2,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 2.2,
            spaceBetween: 12
          }
        },
        on: {
          init() {
            if (paginationEl) paginationEl.style.visibility = 'visible'
            if (nextEl) nextEl.style.visibility = 'visible'
            if (prevEl) prevEl.style.visibility = 'visible'
          }
        }
      })
    }
    function destroySwiper() {
      if (!swiperInstance) return
      try {
        const el = swiperInstance.el
        const paginationEl = el.querySelector('.swiper-pagination')
        const nextEl = el.querySelector('.swiper-button-next')
        const prevEl = el.querySelector('.swiper-button-prev')
        swiperInstance.destroy(true, true)
        swiperInstance = null
        // 🟢 Restore original inline style (important!)
        if (originalStyle) swiperContainer.setAttribute('style', originalStyle)
        // 🧹 Clean leftover classes
        el.classList.remove('swiper-initialized', 'swiper-horizontal', 'swiper-free-mode', 'swiper-bundle')
        // hide pagination/navigation for desktop
        if (paginationEl) paginationEl.style.visibility = 'hidden'
        if (nextEl) nextEl.style.visibility = 'hidden'
        if (prevEl) prevEl.style.visibility = 'hidden'
      } catch (err) {
        swiperInstance = null
        console.warn('Error destroying Swiper:', err)
      }
    }
    const mql = window.matchMedia('(max-width: 991px)')
    function handleBreakpointChange(e) {
      if (e.matches) {
        createSwiper()
      } else {
        destroySwiper()
      }
    }
    // Initial check
    handleBreakpointChange(mql)
    // MatchMedia listener
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', handleBreakpointChange)
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(handleBreakpointChange)
    }
    // Fallback for environments with no proper media query events
    let resizeTimer = null
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer)
      resizeTimer = setTimeout(function () {
        if (window.innerWidth <= 991) {
          createSwiper()
        } else {
          destroySwiper()
        }
      }, 120)
    })
    // Orientation change for mobile
    window.addEventListener('orientationchange', function () {
      setTimeout(function () {
        if (window.innerWidth <= 991) createSwiper()
        else destroySwiper()
      }, 200)
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.testimonial-swiper', {
    slidesPerView: 1.7,
    spaceBetween: 30,
    centeredSlides: true,
    pagination: {
      el: '.testimonial-swiper .swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.testimonial-swiper .swiper-button-next',
      prevEl: '.testimonial-swiper .swiper-button-prev'
    },
    loop: true,
    breakpoints: {
      768: {
        slidesPerView: 1.7,
        spaceBetween: 20
      },
      0: {
        slidesPerView: 1.1,
        spaceBetween: 10
      }
    }
  })

  } catch(e) { console.error(e); }
})();
})();
